<template>
  <div class="card">
    <h1 class="cardTitle">
      {{title}}
      <a v-if="link" :href="link" target="_blank">
        <i class="material-icons">launch</i>
      </a>
    </h1>
    <p class="cardPara">{{desc}}</p>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: ["title", "desc", "link"]
};
</script>

<style lang="scss">
@import "./Card.scss";
</style>